module.exports = __webpack_public_path__ + "static/media/28DGC12.756a78d5.jpg";